import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewSchemaModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewSchemaModal: React.FC<ViewSchemaModalProps> = ({ open, onClose }) => {
  const { selectedSchema, loading } = useAppSelector((state) => state.schemas);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle del Esquema</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedSchema ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Nombre del Esquema
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.schemaName}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.description}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1">
                {selectedSchema.updatedAt}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay esquema seleccionado</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewSchemaModal;
